import { useDatasetDataRes } from '../../../api/types/types';
import { Form, JSONObject } from '../../../types/types';

export const createRelevantFormData = (
  rowData: useDatasetDataRes | undefined,
  form: Form | null | undefined
): JSONObject => {
  const firstRowData = rowData?.data?.[0];

  if (!firstRowData || !form?.items) {
    return {};
  }

  // Keep full GET payload in formData so runtime decorators can resolve helper fields not present in form.items.
  const relevantFormData: JSONObject = { ...firstRowData };

  form.items.forEach((item) => {
    if (
      item.name &&
      Object.prototype.hasOwnProperty.call(relevantFormData, item.name)
    ) {
      return;
    }
    if (item.control?.type === 'radioBtn') {
      const controlItems = item.control.items;
      if (!Array.isArray(controlItems)) return;

      const controlDefault = item.control.default;
      let resolved = controlItems[0];
      if (controlDefault !== undefined) {
        const match = controlItems.find((ci) => ci.value === controlDefault);
        if (match) resolved = match;
      }
      if (resolved?.value === undefined || !item.name) return;

      relevantFormData[item.name] = resolved.value as
        | string
        | number
        | boolean
        | null;
      return;
    }

    if (item.control?.type === 'combobox') {
      const controlItems = item.control.items;
      if (!Array.isArray(controlItems)) return;

      const controlDefault = item.control.default;
      let resolved = controlItems[0];
      if (controlDefault !== undefined) {
        const match = controlItems.find((ci) => ci.value === controlDefault);
        if (match) resolved = match;
      }
      if (resolved?.value === undefined || !item.name) return;

      relevantFormData[item.name] = resolved.value as
        | string
        | number
        | boolean
        | null;
    }
  });

  return relevantFormData;
};
